import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';


const INITIAL_STATE_MANAGE_COLORS = {
  'colors': [],
  'loading': false,
};

export const manageColors = (state, action) => {
  return createReducer(INITIAL_STATE_MANAGE_COLORS, {
    [ActionTypes.FETCHING_MANAGE_COLORS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_MANAGE_COLORS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'colors': [],
    }),
    [ActionTypes.FETCHED_MANAGE_COLORS]: (state, action) => ({
      ...state,
      'loading': false,
      'colors': action.response.data,
    }),
    [ActionTypes.UPDATING_MANAGE_COLORS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_MANAGE_COLORS]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_MANAGE_COLORS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
